// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

// load fonts
WebFont.load({
    active: function() { // helps stop flash of unstyled text
        sessionStorage.fontsLoaded = true
    }
});

//Load Libraries
require('flatpickr/dist/flatpickr.min');
require('magnific-popup/dist/jquery.magnific-popup.min');
require('select2/dist/js/select2.full.min');
require('@accessible360/accessible-slick/slick/slick.min');

//Load Modules
require('./modules/accordion');
require('./modules/formInputs');
require('./modules/videoButtonReplacer');
require('./modules/videoPopup');
require('./modules/videoPopupMp4');
require('./modules/menu');
require('./modules/shareSocial');
require('./modules/tabs');
require('./modules/statistics');
